import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { useAuthStore } from '../../app/store/auth-store';
import { config } from '../../shared/config';

export const SystemInfo: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuthStore();

  const systemStatus = 'online'; // In a real app, this would come from an API
  const statusColor = systemStatus === 'online' ? 'bg-green-500' : 'bg-red-500';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">
          {t('dashboard.systemInfo')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-3 text-sm">
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">{t('dashboard.environment')}:</span>
            <Badge variant="outline" className="font-medium">
              {config.environment}
            </Badge>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">{t('dashboard.systemStatus')}:</span>
            <div className="flex items-center space-x-2">
              <div className={`h-2 w-2 rounded-full ${statusColor}`} />
              <span className="font-medium capitalize">
                {t(`dashboard.status.${systemStatus}`)}
              </span>
            </div>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">{t('dashboard.userRole')}:</span>
            <Badge variant={user?.isSuperuser ? 'default' : 'secondary'}>
              {user?.isSuperuser ? t('dashboard.superuser') : t('dashboard.user')}
            </Badge>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">{t('dashboard.apiEndpoint')}:</span>
            <span className="font-mono text-xs text-muted-foreground truncate max-w-[200px]">
              {config.apiUrl}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};